export const API_LOGOUT = "https://cafe-notes-api.herokuapp.com/api/logout";
